import type { ColDef, ColGroupDef } from 'ag-grid-enterprise';

export const ASSET_ALERTS_TABLE_COLUMNS: (ColDef | ColGroupDef)[] = [
  { field: 'alert_name', headerName: 'Alert', width: 200, flex: 1 },
  { field: 'count', headerName: 'Total Alerts', width: 150 }
];

export default ASSET_ALERTS_TABLE_COLUMNS;
